import Header from './Header';
import LearningHeader from './learning-header/LearningHeader';
import messages from './i18n/index';
import StudioHeader from './studio-header';

export { LearningHeader, messages, StudioHeader };

export default Header;
